export type IListGeneralForm = {
  listname: string;
  listDescription: string;
  entity: any;
  attribute: any;
};

export type IMyWatchListGeneralForm = {
  fleetname: string;
  color: string;
  active: any;
};

export type IListObject = {
  listId?: any;
  listName: string;
  listDesc: string;
  masterEntityId: any;
  masterAttributeId: any;
  listEntries?: any;
};

export type IMyWatchListObject = {
  fleetId?: any;
  fleetName: string;
  color: string;
  active: any;
  employeeId?: any;
};

export type IListEntryForm = {
  entryName: string;
  reason: string;
  enteredDate: any;
  validTillDate: any;
  removedDate: any;
  entryStatus?: any;
  createdBy?: null;
  modifiedBy?: null;
  createdDate?: null;
  modifiedDate?: null;
  entryDisplayName?: string;
};

export type IFleetVesselForm = {
  vesselIMO: string;
  vesselName: string;
  active: any;
};

export type IFleetVesselExcelForm = {
  vesselIMO: string;
  active: any;
};

export type IListEntriesObject = {
  listEntryId?: number;
  listId?: number;
  entryName: any;
  reason: string;
  enteredDate: any;
  validTillDate: any;
  removedDate: any;
  entryStatus?: any;
  entryValue?: any;
  entryDisplayName?: any;
};

export type IFleetVesselObject = {
  imonumber: string;
  fleetId: number;
  active: boolean;
};

export enum ListAttributes {
  DateTime = 'DateTime',
  Number = 'Number',
}
